<template>
  <div v-if="loading" class="bg-white shadow overflow-hidden rounded-md">
    <div class="px-6 py-4 text-center">
      <Loader />
    </div>
  </div>
  <PersonCard v-else-if="person" :person="person" />
  <PersonCreateOrAssociate v-else :contact-id="contactId" @changed="fetchPerson" />
</template>

<script>
import { contactPersonClient } from '@/api/clients';
import { PEOPLE } from '@/store/entities/schema_types';
import PersonCard from './personManager/PersonCard.vue';
import PersonCreateOrAssociate from './personManager/PersonCreateOrAssociate.vue';

export default {
  components: {
    PersonCard,
    PersonCreateOrAssociate,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      personId: null,
    };
  },
  computed: {
    person() {
      if (!this.personId) {
        return null;
      }

      return this.$store.state.entities.people.byId[this.personId] || null;
    },
  },
  created() {
    this.fetchPerson();
  },
  methods: {
    async fetchPerson() {
      try {
        this.loading = true;

        const response = await contactPersonClient.read(this.contactId);

        this.personId = await this.$store.dispatch('entities/persistEntities', {
          type: PEOPLE,
          data: response.data,
        });
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
